// What `renderBanner` takes: the banner's markup with the block's own display
// and styling settings, which is what the SDK is handed on the shop. Shared by
// the two tabs that preview the same block, so the thumbnail on the content tab
// cannot drift from the full-size preview on the appearance one.
const previewBannerPayload = (banner, bannerBlock) => ({
  html: banner?.html,
  cssStyles: bannerBlock.cssStyles,
  displayType: bannerBlock.displayType,
  displayPosition: bannerBlock.displayPosition,
  token: bannerBlock.token,
  bannerId: bannerBlock.bannerId,
});

export default previewBannerPayload;
